[
  {
    "id": "lait-demi-ecreme",
    "name": "Lait demi-écrémé",
    "aliases": ["lait"],
    "category_key": "cremerie",
    "unit_label": "bouteille",
    "pack_size": 6,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "lait-entier",
    "name": "Lait entier",
    "category_key": "cremerie",
    "unit_label": "bouteille",
    "pack_size": 6,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "beurre",
    "name": "Beurre",
    "aliases": ["beurre doux"],
    "category_key": "cremerie",
    "unit_label": "plaquette",
    "pack_size": 1,
    "contents_qty": 250,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "beurre-demi-sel",
    "name": "Beurre demi-sel",
    "category_key": "cremerie",
    "unit_label": "plaquette",
    "pack_size": 1,
    "contents_qty": 250,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "creme-fraiche",
    "name": "Crème fraîche",
    "aliases": ["creme"],
    "category_key": "cremerie",
    "unit_label": "pot",
    "pack_size": 1,
    "contents_qty": 20,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "creme-liquide",
    "name": "Crème liquide",
    "aliases": ["creme fleurette"],
    "category_key": "cremerie",
    "unit_label": "brique",
    "pack_size": 1,
    "contents_qty": 20,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "oeufs",
    "name": "Œufs",
    "aliases": ["oeuf"],
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 6,
    "rate_qty": 4,
    "rate_per_days": 7
  },
  {
    "id": "yaourts-nature",
    "name": "Yaourts nature",
    "aliases": ["yaourt", "yogourt"],
    "category_key": "cremerie",
    "unit_label": "pot",
    "pack_size": 4,
    "contents_qty": 125,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 1
  },
  {
    "id": "yaourts-aux-fruits",
    "name": "Yaourts aux fruits",
    "category_key": "cremerie",
    "unit_label": "pot",
    "pack_size": 4,
    "contents_qty": 125,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 2
  },
  {
    "id": "fromage-blanc",
    "name": "Fromage blanc",
    "category_key": "cremerie",
    "unit_label": "pot",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 10
  },
  {
    "id": "cremes-dessert",
    "name": "Crèmes dessert",
    "aliases": ["creme au chocolat", "flan"],
    "category_key": "cremerie",
    "unit_label": "pot",
    "pack_size": 4,
    "rate_qty": 2,
    "rate_per_days": 7
  },
  {
    "id": "fromage-rape",
    "name": "Fromage râpé",
    "aliases": ["emmental rape", "gruyere rape"],
    "category_key": "cremerie",
    "unit_label": "sachet",
    "pack_size": 1,
    "contents_qty": 200,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "comte",
    "name": "Comté",
    "aliases": ["fromage"],
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 250,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "camembert",
    "name": "Camembert",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 250,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "chevre",
    "name": "Fromage de chèvre",
    "aliases": ["chevre", "buche de chevre"],
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 180,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "mozzarella",
    "name": "Mozzarella",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 125,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "parmesan",
    "name": "Parmesan",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 100,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "feta",
    "name": "Feta",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 200,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "pate-feuilletee",
    "name": "Pâte feuilletée",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 230,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "pate-brisee",
    "name": "Pâte brisée",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "contents_qty": 230,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "pate-a-pizza",
    "name": "Pâte à pizza",
    "category_key": "cremerie",
    "unit_label": "pièce",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 14
  }
]
